import RfiDetailsHeaderActions from './RfiDetailsHeaderActions.component';

export default RfiDetailsHeaderActions;
